function FamilyFriendsCustomer() {
  const registerForm = document.querySelector('[name="CreateInvitedCustomers"]');
  const inviteForm = document.querySelector('[name="InviteCustomer"]');
  const errorsContainer = document.querySelector('.Alert__ErrorList');

  function displayAlert(error, type){
    const errorElement = document.createElement('li');
    errorElement.classList.add('Alert__ErrorItem');
    errorElement.appendChild(document.createTextNode(window.familyFriends.Translations[error.errorCode] || error.error || ''));
    errorsContainer.appendChild(errorElement);
    errorsContainer.parentElement.classList.remove('Alert--error', 'Alert--success');
    errorsContainer.parentElement.classList.add(('Alert--' + type));

    setTimeout(() => {
      errorsContainer.innerHTML = '';
    }, 5000);
  };

  async function getInvitationId(invitationHandle){
    const response = await fetch(`${window.familyFriends.Settings.RandomPageUrl}/handle-${invitationHandle}?section_id=get-invitation-from-handle`).then((response)=>{return response.text()}).catch((error)=>{displayAlert(error, 'error')});;
    const tempElement = document.createElement('div');
    tempElement.innerHTML = response;
    return (JSON.parse(tempElement.children[0].innerHTML) || false);
  }

  async function registerCustomer(e){
    try{
      e.preventDefault();
      e.stopPropagation();
      const formData = new FormData(registerForm);
      const data = Object.fromEntries(formData.entries());
      const invite = await getInvitationId(data['InvitationCode']);

      if(!invite){
        throw {
          errorCode: 'INVITATION_NOT_FOUND',
        };
      }else if(invite && invite.errorCode){
        throw {
          errorCode: invite.errorCode,
        };
      }
      else if(invite && invite.used){
        throw {
          errorCode: 'USED_INVITATION',
        };
      }

      data.InvitationId = invite.id;
      fetch(window.familyFriends.Settings.RegisterEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }).then((response)=>{
        if(response.ok){
          displayAlert({
            errorCode: 'INVITATION_SUCCESS',
          }, 'success');
        }else{
          response.json().then((error)=>{
            displayAlert(error, 'error');
          });
        }
      }).catch((error)=>{
        displayAlert(error, 'error');
      });
    }catch(error){
      displayAlert(error, 'error');
    }

  }

  async function inviteCustomer(e){
    try{
      e.preventDefault();
      e.stopPropagation();
      const formData = new FormData(inviteForm);
      const data = Object.fromEntries(formData.entries());

      fetch(window.familyFriends.Settings.InviteEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      }).then((response)=>{
        if(response.ok){
          displayAlert({
            errorCode: 'CREATE_INVITE_SUCCESS',
          }, 'success');
          e.target.querySelector('[type="submit"]').remove();
        }else{
          response.json().then((error)=>{
            displayAlert(error, 'error');
          });
        }
      }).catch((error)=>{
        displayAlert(error, 'error');
      });
    }catch(error){
      displayAlert(error, 'error');
    }
  }

  function init(){
    if(registerForm){
      registerForm.addEventListener('submit', registerCustomer);
    }
    if(inviteForm){
      inviteForm.addEventListener('submit', inviteCustomer);
    }
  }

  init();
}

document.addEventListener('DOMContentLoaded', FamilyFriendsCustomer);